<template>
  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> LISTADO DE
            PENDIENTES EN CONTRATAR XTRIM
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <!-- Filtros -->
      <div
        v-if="!loading && !notAllow"
        class="row"
        style="
          margin-bottom: 20px;
          padding: 15px;
          background-color: #f5f5f5;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          align-items: end;
        "
      >
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <label
            for="filter-status"
            class="form-label"
            style="font-weight: 600; font-size: 13px; margin-bottom: 5px"
          >
            Filtrar por Estado:
          </label>
          <select
            id="filter-status"
            v-model="selectedStatus"
            class="form-control form-control-sm"
            @change="applyFilters"
            style="font-size: 13px; border-radius: 6px"
          >
            <option value="all">TODOS</option>
            <option
              v-for="status in availableStatuses"
              :key="status"
              :value="status"
            >
              {{ status }}
            </option>
          </select>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <label
            for="filter-week"
            class="form-label"
            style="font-weight: 600; font-size: 13px; margin-bottom: 5px"
          >
            Filtrar por Semana:
          </label>
          <select
            id="filter-week"
            v-model="selectedWeek"
            class="form-control form-control-sm"
            @change="applyFilters"
            style="font-size: 13px; border-radius: 6px"
          >
            <option value="all">TODAS LAS SEMANAS</option>
            <option value="current">SEMANA PRESENTE</option>
            <option value="previous">SEMANA ANTERIOR</option>
          </select>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <button
            @click="downloadExcel"
            class="btn btn-success"
            style="
              width: 100%;
              border-radius: 6px;
              font-weight: 600;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              padding: 8px 16px;
            "
          >
            <i class="fas fa-file-excel" style="font-size: 18px"></i>
            Descargar Excel
          </button>
        </div>
      </div>

      <div
        v-if="!loading && !notAllow"
        style="
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          align-items: center;
          margin: 0 0 12px 10px;
          font-size: 13px;
          color: #555;
        "
      >
        <span style="font-weight: 600">Leyenda:</span>
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <i
            class="fas fa-building"
            style="color: #28a745; font-size: 1.1em"
          ></i>
          Empresa (Cadena de tiendas)
        </span>
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <i
            class="fas fa-sitemap"
            style="color: #7d0c7e; font-size: 1.1em"
          ></i>
          Multinivel
        </span>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />

          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="sales"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha/Hora</th>
            <th>Promotor</th>
            <th># Promotor</th>
            <th data-priority="1">Referido</th>
            <th># Referido</th>
            <th>Tecnología</th>
            <th>Coordenadas</th>
            <th data-priority="2">Estado</th>
            <th data-priority="3">Notas</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
  <VueFinalModal
    v-model="showModal"
    :esc-to-close="true"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal__content">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        "
      >
        <div style="display: flex; flex-direction: column">
          <label>Ingresado el: </label>
          <p
            class="form-control"
            style="margin: 0; padding: 0.2rem 0.5rem; width: fit-content"
          >
            {{ sale.dateFormatted }}
          </p>
        </div>
        <div style="display: flex; flex-direction: column; gap: 8px">
          <label style="margin-bottom: 0">Recordatorio: </label>
          <input
            type="datetime-local"
            class="form-control"
            v-model="reminderDate"
            style="width: fit-content; margin: 0; padding: 0.2rem 0.5rem"
          />
          <input
            type="text"
            class="form-control"
            v-model="reminderNote"
            style="margin: 0; padding: 0.2rem 0.5rem"
            placeholder="Ingresar Nota"
          />
          <button
            class="btn btn-primary"
            id="buttonAddReminder"
            style="
              padding: 0.4rem 0.625rem;
              width: fit-content;
              align-self: end;
            "
            @click="addReminder({ reminderDate, reminderNote })"
            :disabled="isAdding"
          >
            Agregar
          </button>
        </div>
      </div>
      <label>Promotor: </label>
      <p class="form-control" style="margin: 0; padding: 0.2rem 0.5rem">
        {{ `${sale.promoterNames} ${sale.promoterLastnames}` }}
        <i
          v-if="sale.isEnterprise === true"
          class="fas fa-building"
          style="color: #28a745; margin-left: 5px; font-size: 1.1em"
          title="Cadena de tiendas"
        ></i>
        <i
          v-if="sale.identifiedByEmployeeCode === true"
          class="fas fa-sitemap"
          style="color: #7d0c7e; margin-left: 5px; font-size: 1.1em"
          :title="
            sale.promoterEmployeeCode
              ? `Multinivel (${sale.promoterEmployeeCode})`
              : 'Multinivel'
          "
        ></i>
      </p>
      <label v-if="sale.promoterPhone"> Llamar Promotor:</label>
      <p
        class="form-control copyable-field"
        v-if="sale.promoterPhone"
        style="font-weight: 600; margin: 0; padding: 0.2rem 0.5rem"
        @click="
          copyTextToClipboard(sale.promoterPhone, 'Teléfono del promotor')
        "
      >
        <a :href="'tel:' + sale.promoterPhone">{{ sale.promoterPhone }}</a>
      </p>

      <!-- Company Information (solo para ventas normales) -->
      <template v-if="!sale.isEnterprise && sale.clientType === 'company'">
        <label>Empresa: </label>
        <p
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.displayName, 'Razón social')"
        >
          {{ sale.displayName }}
        </p>
        <label>RUC: </label>
        <p
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.ruc, 'RUC')"
        >
          {{ sale.ruc }}
        </p>
      </template>

      <!-- Natural Person Information -->
      <template v-else>
        <label>Cliente: </label>
        <p
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.displayName, 'Nombre del cliente')"
        >
          {{ sale.displayName }}
        </p>
        <div style="display: flex; gap: 8px; width: 100%">
          <div style="width: 50%">
            <label>Cédula: </label>
            <p
              class="form-control copyable-field"
              style="margin: 0; padding: 0.2rem 0.5rem"
              @click="copyTextToClipboard(sale.dni, 'Cédula')"
            >
              {{ sale.dni }}
            </p>
          </div>
          <!-- Código Dactilar solo para ventas normales -->
          <div
            v-if="!sale.isEnterprise && sale.fingerPrintCode"
            style="width: 50%"
          >
            <label>Código Dactilar: </label>
            <p
              class="form-control copyable-field"
              style="margin: 0; padding: 0.2rem 0.5rem"
              @click="
                copyTextToClipboard(sale.fingerPrintCode, 'Código dactilar')
              "
            >
              {{ sale.fingerPrintCode }}
            </p>
          </div>
        </div>
      </template>

      <!-- Email solo para ventas normales -->
      <template v-if="!sale.isEnterprise && sale.email">
        <label>Email: </label>
        <p
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.email, 'Email')"
        >
          {{ sale.email }}
        </p>
      </template>

      <label>Teléfono: </label>
      <p
        class="form-control copyable-field"
        style="margin: 0; padding: 0.2rem 0.5rem"
        @click="copyTextToClipboard(sale.phone, 'Teléfono')"
      >
        {{ sale.phone }}
      </p>

      <!-- Dirección y campos relacionados solo para ventas normales -->
      <template v-if="!sale.isEnterprise">
        <label v-if="sale.address">Dirección: </label>
        <p
          v-if="sale.address"
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.address, 'Dirección')"
        >
          {{ sale.address }}
        </p>
        <label v-if="sale.mainSt">Calle Principal: </label>
        <p
          v-if="sale.mainSt"
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.mainSt, 'Calle principal')"
        >
          {{ sale.mainSt }}
        </p>
        <label v-if="sale.secondarySt">Calle Secundaria: </label>
        <p
          v-if="sale.secondarySt"
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.secondarySt, 'Calle secundaria')"
        >
          {{ sale.secondarySt }}
        </p>
        <div
          v-if="sale.block || sale.lotNumber"
          style="display: flex; gap: 8px; width: 100%"
        >
          <div v-if="sale.block" style="width: 50%">
            <label>Manzana: </label>
            <p
              class="form-control copyable-field"
              style="margin: 0; padding: 0.2rem 0.5rem"
              @click="copyTextToClipboard(sale.block, 'Manzana')"
            >
              {{ sale.block }}
            </p>
          </div>
          <div v-if="sale.lotNumber" style="width: 50%">
            <label>Villa: </label>
            <p
              class="form-control copyable-field"
              style="margin: 0; padding: 0.2rem 0.5rem"
              @click="copyTextToClipboard(sale.lotNumber, 'Villa')"
            >
              {{ sale.lotNumber }}
            </p>
          </div>
        </div>
        <label v-if="sale.reference">Referencia: </label>
        <p
          v-if="sale.reference"
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="copyTextToClipboard(sale.reference, 'Referencia')"
        >
          {{ sale.reference }}
        </p>
      </template>

      <!-- Coordenadas (mostrar para ambos tipos) -->
      <div v-if="sale.location || (sale.latitude && sale.longitude)">
        <label>Coordenadas: </label>
        <p
          class="form-control copyable-field"
          style="margin: 0; padding: 0.2rem 0.5rem"
          @click="
            copyCoordinates(
              sale.latitude || sale.location?._latitude,
              sale.longitude || sale.location?._longitude,
            )
          "
        >
          {{ sale.latitude || sale.location?._latitude }},
          {{ sale.longitude || sale.location?._longitude }}
        </p>
      </div>

      <!-- Services Section solo para ventas normales -->
      <div
        v-if="
          !sale.isEnterprise &&
          (sale.wantsInternet || sale.wantsPhone || sale.wantsTv)
        "
        class="services-section"
      >
        <label>Servicios Solicitados:</label>
        <div class="services-container">
          <div class="service-card" :class="{ active: sale.wantsInternet }">
            <i class="fas fa-wifi service-icon"></i>
            <span class="service-name">Internet</span>
            <div class="service-status">
              {{ sale.wantsInternet ? "Solicitado" : "No solicitado" }}
            </div>
          </div>
          <div class="service-card" :class="{ active: sale.wantsPhone }">
            <i class="fas fa-phone-alt service-icon"></i>
            <span class="service-name">Teléfono</span>
            <div class="service-status">
              {{ sale.wantsPhone ? "Solicitado" : "No solicitado" }}
            </div>
          </div>
          <div class="service-card" :class="{ active: sale.wantsTv }">
            <img
              :src="zappingLogo"
              alt=""
              class="zapping-service-logo"
              width="22"
              height="22"
            />
            <span class="service-name service-name--zapping">Zapping</span>
            <div class="service-status">
              {{ sale.wantsTv ? "Solicitado" : "No solicitado" }}
            </div>
          </div>
        </div>

        <div class="budget-description-container">
          <div v-if="sale.budget" class="budget-box">
            <h5 class="budget-title">Presupuesto Mensual</h5>
            <div class="budget-value">${{ sale.budget }}</div>
          </div>

          <div v-if="sale.description" class="description-box">
            <h5 class="description-title">Descripción</h5>
            <div class="description-content">{{ sale.description }}</div>
          </div>
        </div>
      </div>

      <label>Estado: </label>
      <div
        style="
          display: flex;
          align-items: center;
          gap: 10px;
        "
      >
        <p
          class="form-control"
          style="
            margin: 0;
            padding: 0.2rem 0.5rem;
            flex: 1;
            min-width: 0;
          "
        >
          {{ sale.status }}
        </p>
        <button
          v-if="sale.completed === true"
          type="button"
          class="btn btn-primary btn-sm"
          style="
            background-color: #7d0c7e;
            color: white;
            border-color: #7d0c7e;
            width: 110px;
            flex-shrink: 0;
          "
          :disabled="isReactivating"
          @click="reactivateSale(sale.saleId)"
        >
          Reactivar
        </button>
      </div>
      <div v-if="sale.notes">
        <label>Notas:</label>
        <div
          v-for="(note, index) in sale.notes"
          :key="index"
          class="notesContainer"
        >
          <p style="margin: 0 0 0 8px; display: flex; gap: 8px">
            <span style="font-size: 10px; align-self: center">{{
              index + 1
            }}</span>
            {{ note.note }}
          </p>
          <p
            style="
              margin: 0 8px 0 0;
              font-style: italic;
              font-size: 11px;
              color: #979797;
            "
          >
            {{ note.date }}
          </p>
        </div>
      </div>
      <label>Agregar Nota: </label>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          gap: 6px;
        "
      >
        <input
          v-model="note"
          class="form-control"
          style="margin: 0; padding: 0.2rem 0.5rem"
          placeholder="Ingresar anotación"
        />
        <button
          class="btn btn-primary"
          id="buttonAdd"
          style="padding: 0.4rem 0.625rem; width: fit-content; align-self: end"
          :disabled="isButtonDisabled"
          @click="
            addNote({
              userId: sale.userId,
              saleId: sale.saleId,
              note: note,
              tokenAuth: this.tokenAuth,
              adminId: this.adminId,
            })
          "
        >
          Agregar
        </button>
      </div>
    </div>
  </VueFinalModal>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import * as XLSX from "xlsx";
import zappingLogo from "@/assets/img/Xtrim/zapping.svg";

DataTable.use(DataTablesCore);
// R+Bms7+k+JItZLrJ+nOrKKRYv94Nj/wnuu/4uIrFa06njgaUZNKT5jsONy50K3C/bGHNPKHD6Ra0IMxMchl5PvT7Kn9KXo/J8IyFc7xkT1wFA3xbOoXGjoUtW6kvDufRmHDphGsu16LgTrzfQzh8Xzk2mOHEMUqfcYlXk8Vfr1s=
export default {
  components: {
    DataTable,
    VueFinalModal,
  },
  props: ["userId", "tokenAuth", "role", "userRole"],
  data() {
    let userId = this.$store.state.user.userId;
    return {
      loading: true,
      sales: [],
      allSales: [], // Store all sales for filtering
      notAllow: false,
      showModal: false,
      sale: null,
      note: null,
      reminderNote: null,
      isAdding: false,
      reminderDate: null,
      adminId: userId,
      isReactivating: false,
      // Filter selections
      selectedStatus: "all",
      selectedWeek: "all",
      availableStatuses: [],
      columns: [
        { data: "dateFormatted" },
        {
          data: null,
          render: function (data, type, row, meta) {
            const promoterName = `${data.promoterNames + " " + data.promoterLastnames}`;
            const isEnterprise = data.isEnterprise === true;
            let html = promoterName;
            if (isEnterprise) {
              html += ` <i class="fas fa-building" style="color: #28a745; margin-left: 5px; font-size: 1.1em;" title="Cadena de tiendas"></i>`;
            }
            if (data.identifiedByEmployeeCode === true) {
              const code = data.promoterEmployeeCode
                ? ` (${data.promoterEmployeeCode})`
                : "";
              html += ` <i class="fas fa-sitemap" style="color: #7d0c7e; margin-left: 5px; font-size: 1.1em;" title="Multinivel${code}"></i>`;
            }
            return html;
          },
        },
        {
          data: null,
          render: function (data, type, row, meta) {
            return data.promoterPhone;
          },
        },

        { data: "displayName" },
        { data: "phone" },
        {
          data: null,
          render: function (data) {
            return `<b>${
              data.isGponAvailable
                ? "GPON"
                : !(data.isGponAvailable === undefined)
                  ? "HFC"
                  : "No disponible"
            }</b>`;
          },
        },

        // {
        //   data: null,
        //   render: function (data, type, row, meta) {
        //     if (row.canal ?? row.canal === "WhatsApp") {
        //       return '<span style="background: #28a745; color: white;" class="badge badge-success">WhatsApp</span>';
        //     } else {
        //       return '<span style="width:65px" class="badge badge-secondary">Web</span>';
        //     }
        //   },
        // },
        {
          data: null,
          render: (data, type, row, meta) => {
            if (!row.location) return "";
            const latitude = row.location._latitude;
            const longitude = row.location._longitude;
            return `
              <button class="btn btn-primary btn-sm copy-coordinates" style="display: flex; align-items: center; gap: 5px;" data-latitude="${latitude}" data-longitude="${longitude}">
                Copiar <i class="fas fa-location-dot"></i>
              </button>`;
          },
        },
        {
          data: null,
          render: function (data, type, row, meta) {
            if (data.completed) {
              return data.status;
            }
            return `
            <div class="dropdown">
            <button class="btn btn-primary btn-sm dropdown-toggle " type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                ${data.status}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu2" style="background-color: white !important;">
                <li><button data-id="${data.saleId}" data-status="INSTALADO: Contrato instalado"  data-open="false"  class="aprobar dropdown-item" type="button">INSTALADO: Contrato instalado</button></li>
                <li><button data-id="${data.saleId}" data-status="NO DESEA" data-open="false" class="aprobar dropdown-item" type="button">NO DESEA</button></li>
                <li><button data-id="${data.saleId}" data-status="SIN COBERTURA / NO APLICA" data-open="false" class="aprobar dropdown-item" type="button">SIN COBERTURA / NO APLICA</button></li>
                <li><button data-id="${data.saleId}" data-status="EN NEGOCIACIÓN" data-open="true" class="aprobar dropdown-item" type="button">EN NEGOCIACIÓN</button></li>
                <li><button data-id="${data.saleId}" data-status="NO CONTESTA" data-open="true" class="aprobar dropdown-item" type="button">NO CONTESTA</button></li>
                <li><button data-id="${data.saleId}" data-status="PENDIENTE INSTALACIÓN" data-open="true" class="aprobar dropdown-item" type="button">PENDIENTE INSTALACIÓN</button></li>
                <li><button data-id="${data.saleId}" data-status="INCONTACTABLE" data-open="false" class="aprobar dropdown-item" type="button">INCONTACTABLE</button></li>
                <li><button data-id="${data.saleId}" data-status="CLIENTE EXISTENTE" data-open="false" class="aprobar dropdown-item" type="button">CLIENTE EXISTENTE</button></li>
                <li><button data-id="${data.saleId}" data-status="CONTRATA POR OTRO CANAL" data-open="false" class="aprobar dropdown-item" type="button">CONTRATA POR OTRO CANAL</button></li>
                <li><button data-id="${data.saleId}" data-status="TERCERA EDAD" data-open="false" class="aprobar dropdown-item" type="button">TERCERA EDAD</button></li>
                <li><button data-id="${data.saleId}" data-status="PENDIENTE DOCUMENTACIÓN" data-open="true" class="aprobar dropdown-item" type="button">PENDIENTE DOCUMENTACIÓN</button></li>
                <li><button data-id="${data.saleId}" data-status="PENDIENTE VALIDACIÓN BIOMÉTRICA" data-open="true" class="aprobar dropdown-item" type="button">PENDIENTE VALIDACIÓN BIOMÉTRICA</button></li>
                <li><button data-id="${data.saleId}" data-status="NO APTO PARA CONTRATACIÓN" data-open="false" class="aprobar dropdown-item" type="button">NO APTO PARA CONTRATACIÓN</button></li>
                <li><button data-id="${data.saleId}" data-status="BANDEJA DE CALIDAD" data-open="true" class="aprobar dropdown-item" type="button">BANDEJA DE CALIDAD</button></li>
                <li><button data-id="${data.saleId}" data-status="NAP SATURADA" data-open="false" class="aprobar dropdown-item" type="button">NAP SATURADA</button></li>
                <li><button data-id="${data.saleId}" data-status="CRUCE DE VENTAS" data-open="true" class="aprobar dropdown-item" type="button">CRUCE DE VENTAS</button></li>
                <li><button data-id="${data.saleId}" data-status="PROBLEMAS TECNICOS" data-open="false" class="aprobar dropdown-item" type="button">PROBLEMAS TECNICOS</button></li>
                <li><button data-id="${data.saleId}" data-status="CERRADO: Sin compra después de 30 días." data-open="false" class="aprobar dropdown-item" type="button">CERRADO: Sin compra después de 30 días.</button></li>
                </ul>
            </div>`;
          },
        },

        {
          data: null,
          render: function (data, type, row, meta) {
            const notes = data.notes ? data.notes : "No hay notas";
            const dataString = JSON.stringify(data).replace(/"/g, "&quot;"); // Escape double quotes
            return `
              <div>
                <button type="button" style="width: max-content;"  class="btn btn-primary btn-sm toggle-notes" data-transaction-id="${data.id}" data-sale="${dataString}">
                  Ver notas
                </button>
              </div>`;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
          infoFiltered: " - filtrados de _MAX_ registros",
        },
      },
    };
  },
  computed: {
    isButtonDisabled() {
      return !this.note || this.isAdding;
    },
  },
  watch: {
    showModal() {
      if (!this.showModal) {
        this.note = "";
        this.reminderDate = null;
        this.reminderNote = null;
        this.sale = null;
      }
    },
  },
  mounted() {
    $(document).off("click", ".aprobar");
    $(document).off("click", ".copy-coordinates");
    $(document).off("click", ".copyable-field");

    $(document).on("click", ".aprobar", (evt) => {
      const id = $(evt.target).data("id");
      const status = $(evt.target).data("status");
      const open = $(evt.target).data("open");
      this.updateStatus(id, status, open);
    });

    $(document).on("click", ".copy-coordinates", (evt) => {
      const latitude = $(evt.currentTarget).data("latitude");
      const longitude = $(evt.currentTarget).data("longitude");
      this.copyCoordinates(latitude, longitude);
    });

    $(document).on("click", ".copyable-field", (evt) => {
      const value = $(evt.currentTarget).data("value");
      const fieldName = evt.currentTarget.classList.contains("copy-promoter")
        ? "Nombre del promotor"
        : evt.currentTarget.classList.contains("copy-promoter-phone")
          ? "Teléfono del promotor"
          : evt.currentTarget.classList.contains("copy-display-name")
            ? "Nombre del cliente"
            : evt.currentTarget.classList.contains("copy-phone")
              ? "Teléfono del cliente"
              : "Texto";
      this.copyTextToClipboard(value, fieldName);
    });

    const vm = this;
    $(document).ready(function () {
      $(document).on("click", ".toggle-notes", function () {
        const sale = $(this).data("sale");
        vm.sale = sale;
        vm.showModal = true;
      });
    });

    this.fetchPendingSales();
  },
  methods: {
    copyCoordinates(latitude, longitude) {
      const coordText = `${latitude}, ${longitude}`;
      navigator.clipboard
        .writeText(coordText)
        .then(() => {
          this.$toast.success("Coordenadas copiadas exitosamente", {
            position: "top-right",
            max: 10,
          });
        })
        .catch((err) => {
          this.$toast.error("Error al copiar coordenadas", {
            position: "top-right",
            max: 10,
          });
          console.error("Error al copiar al portapapeles: ", err);
        });
    },

    copyTextToClipboard(text, fieldName) {
      if (!text) return;

      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success(`${fieldName} copiado exitosamente`, {
            position: "top-right",
            max: 10,
          });
        })
        .catch((err) => {
          this.$toast.error(`Error al copiar ${fieldName}`, {
            position: "top-right",
            max: 10,
          });
          console.error("Error al copiar al portapapeles: ", err);
        });
    },

    updateStatus(saleId, status, open) {
      this.triggerStatusChange(saleId, status, open);
    },

    reactivateSale(saleId) {
      this.isReactivating = true;
      this.$https
        .post("/administration/reactivateSale/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          saleId,
        })
        .then((response) => {
          this.isReactivating = false;
          if (this.sale && this.sale.saleId === saleId) {
            this.sale.completed = false;
          }
          this.fetchPendingSales();
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
        })
        .catch((error) => {
          this.isReactivating = false;
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error(error.response?.data?.message || "Error al reactivar", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else {
            this.$toast.error(error.response?.data?.message || "Error al reactivar", {
              position: "top-right",
              max: 10,
            });
          }
        });
    },

    triggerStatusChange(saleId, status, open) {
      this.$swal({
        html: '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Cambiando status</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        position: "top",
      });

      this.$https
        .post("/administration/updateSaleStatus/", {
          tokenAuth: this.tokenAuth,
          saleId,
          newStatus: status,
          userId: this.userId,
          open,
        })
        .then((response) => {
          this.$swal.close();
          this.fetchPendingSales(); // Reload data and reapply filters
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else {
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
          }
          this.$swal.close();
        });
    },

    refresh() {
      $(document).off("click", ".consultar");
      this.$eventBus.emit("reiniciarListadoVentasAdmin");
    },

    fetchPendingSales() {
      this.$https
        .post("/administration/fetchPendingSales/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loading = false;
          this.notAllow = false;
          this.allSales = response.data.sales || [];
          
          // Extract unique statuses for filter dropdown
          const statusSet = new Set();
          this.allSales.forEach((sale) => {
            if (sale.status) {
              statusSet.add(sale.status);
            }
          });
          this.availableStatuses = Array.from(statusSet).sort();
          
          // Apply initial filters
          this.applyFilters();
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 403) {
            this.loading = false;
            this.$router.push({ name: "Dashboard" });
            this.$toast.error("Acceso no autorizado", {
              position: "top-right",
              max: 10,
            });
          } else {
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
          }

          // this.fetchPendingSales();
        });
    },
    applyFilters() {
      let filtered = [...this.allSales];

      // Filter by status
      if (this.selectedStatus !== "all") {
        filtered = filtered.filter(
          (sale) => sale.status === this.selectedStatus
        );
      }

      // Filter by week
      if (this.selectedWeek !== "all") {
        const weekRange = this.getWeekRange(this.selectedWeek);
        filtered = filtered.filter((sale) => {
          const saleDate = this.getSaleDate(sale);
          if (!saleDate) return false;
          return saleDate >= weekRange.start && saleDate <= weekRange.end;
        });
      }

      this.sales = filtered;
    },
    getSaleDate(sale) {
      // Try to get date from createdAt field (Firestore timestamp)
      if (sale.createdAt) {
        if (sale.createdAt._seconds) {
          return new Date(sale.createdAt._seconds * 1000);
        } else if (sale.createdAt instanceof Date) {
          return sale.createdAt;
        } else if (sale.createdAt.toDate) {
          return sale.createdAt.toDate();
        }
      }
      
      // Fallback to date field
      if (sale.date) {
        if (sale.date._seconds) {
          return new Date(sale.date._seconds * 1000);
        } else if (sale.date instanceof Date) {
          return sale.date;
        } else if (sale.date.toDate) {
          return sale.date.toDate();
        }
      }
      
      return null;
    },
    getWeekRange(weekType) {
      // Get current date in Ecuador timezone (America/Guayaquil)
      // Use Intl.DateTimeFormat to get date components in Ecuador timezone
      const now = new Date();
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Guayaquil",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      
      const parts = formatter.formatToParts(now);
      const year = parseInt(parts.find((p) => p.type === "year").value);
      const month = parseInt(parts.find((p) => p.type === "month").value) - 1; // 0-indexed
      const day = parseInt(parts.find((p) => p.type === "day").value);
      const hour = parseInt(parts.find((p) => p.type === "hour").value);
      const minute = parseInt(parts.find((p) => p.type === "minute").value);
      const second = parseInt(parts.find((p) => p.type === "second").value);
      
      const ecuadorTime = new Date(year, month, day, hour, minute, second);
      
      // Get current day of week (0 = Sunday, 1 = Monday, etc.)
      const dayOfWeek = ecuadorTime.getDay();
      
      // Calculate start of current week (Monday)
      const startOfCurrentWeek = new Date(ecuadorTime);
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // If Sunday, go back 6 days
      startOfCurrentWeek.setDate(ecuadorTime.getDate() - daysToMonday);
      startOfCurrentWeek.setHours(0, 0, 0, 0);
      
      // Calculate end of current week (Sunday)
      const endOfCurrentWeek = new Date(startOfCurrentWeek);
      endOfCurrentWeek.setDate(startOfCurrentWeek.getDate() + 6);
      endOfCurrentWeek.setHours(23, 59, 59, 999);
      
      if (weekType === "current") {
        return {
          start: startOfCurrentWeek,
          end: endOfCurrentWeek,
        };
      } else if (weekType === "previous") {
        // Previous week: 7 days before current week
        const startOfPreviousWeek = new Date(startOfCurrentWeek);
        startOfPreviousWeek.setDate(startOfCurrentWeek.getDate() - 7);
        startOfPreviousWeek.setHours(0, 0, 0, 0);
        
        const endOfPreviousWeek = new Date(startOfPreviousWeek);
        endOfPreviousWeek.setDate(startOfPreviousWeek.getDate() + 6);
        endOfPreviousWeek.setHours(23, 59, 59, 999);
        
        return {
          start: startOfPreviousWeek,
          end: endOfPreviousWeek,
        };
      }
      
      return { start: null, end: null };
    },
    addNote(body) {
      this.isAdding = true;
      document.getElementById("buttonAdd").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Agregando...';
      this.$https
        .post("/administration/addNote/", body)
        .then((response) => {
          this.note = null;
          this.showModal = false;
          this.isAdding = false;
          this.fetchPendingSales();
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
          document.getElementById("buttonAdd").innerHTML = "Agregar";
        })
        .catch((error) => {
          this.$toast.error(error, {
            position: "top-right",
            max: 10,
          });
          document.getElementById("buttonAdd").innerHTML = "Agregar";
          this.note = null;
          this.showModal = false;
          this.isAdding = false;
          console.log(error);
        });
    },
    addReminder(body) {
      this.isAdding = true;
      document.getElementById("buttonAddReminder").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Agregando...';
      let date = null;
      let time = null;
      let noteToAdd = `Cliente ${this.sale.displayName} - ${this.sale.phone}${this.reminderNote ? " - " + this.reminderNote : ""}`;

      if (body.reminderDate) {
        // Split by 'T' to separate date and time
        const datetime = this.reminderDate.split("T");
        time = datetime[1];
        date = datetime[0].split("-").reverse().join("-");
      } else {
        this.$toast.error("Debe seleccionar una fecha y hora", {
          position: "top-right",
          max: 10,
        });
        document.getElementById("buttonAddReminder").innerHTML = "Agregar";
        this.isAdding = false;
        return;
      }

      this.$https
        .post("/administration/addReminder", {
          date: date,
          time: time,
          note: noteToAdd,
          adminId: this.adminId,
        })
        .then((response) => {
          this.showModal = false;
          this.isAdding = false;
          this.fetchPendingSales();
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
          document.getElementById("buttonAddReminder").innerHTML = "Agregar";
        })
        .catch((error) => {
          this.$toast.error(error, {
            position: "top-right",
            max: 10,
          });
          document.getElementById("buttonAddReminder").innerHTML = "Agregar";
          this.note = null;
          this.showModal = false;
          this.isAdding = false;
          console.log(error);
        });
    },
    downloadExcel() {
      if (this.sales.length === 0) {
        this.$toast.warning("No hay datos para exportar", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      try {
        // Prepare data for Excel export
        const excelData = this.sales.map((sale) => {
          // Format date
          let formattedDate = "-";
          if (sale.createdAt) {
            if (sale.createdAt._seconds) {
              const date = new Date(
                sale.createdAt._seconds * 1000 +
                  (sale.createdAt._nanoseconds || 0) / 1e6,
              );
              formattedDate = date.toLocaleString("es-ES", {
                timeZone: "America/Guayaquil",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            } else if (sale.createdAt instanceof Date) {
              formattedDate = sale.createdAt.toLocaleString("es-ES", {
                timeZone: "America/Guayaquil",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            } else if (sale.createdAt.toDate) {
              const date = sale.createdAt.toDate();
              formattedDate = date.toLocaleString("es-ES", {
                timeZone: "America/Guayaquil",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            }
          } else if (sale.dateFormatted) {
            formattedDate = sale.dateFormatted;
          }

          // Get coordinates
          let coordinates = "-";
          if (sale.latitude && sale.longitude) {
            coordinates = `${sale.latitude}, ${sale.longitude}`;
          } else if (sale.location) {
            coordinates = `${sale.location._latitude || ""}, ${
              sale.location._longitude || ""
            }`;
          }

          // Get technology
          let technology = "No disponible";
          if (sale.isGponAvailable === true) {
            technology = "GPON";
          } else if (sale.isGponAvailable === false) {
            technology = "HFC";
          }

          // Get notes
          const notes =
            sale.notes && sale.notes.length > 0
              ? sale.notes.map((n) => n.note).join(" | ")
              : "No hay notas";

          return {
            "Fecha/Hora": formattedDate,
            Promotor: `${sale.promoterNames || ""} ${sale.promoterLastnames || ""}`.trim(),
            "# Promotor": sale.promoterPhone || "-",
            Referido: sale.displayName || "-",
            "# Referido": sale.phone || "-",
            Tecnología: technology,
            Coordenadas: coordinates,
            Estado: sale.status || "-",
            Notas: notes,
          };
        });

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        const colWidths = [
          { wch: 20 }, // Fecha/Hora
          { wch: 25 }, // Promotor
          { wch: 15 }, // # Promotor
          { wch: 25 }, // Referido
          { wch: 15 }, // # Referido
          { wch: 15 }, // Tecnología
          { wch: 25 }, // Coordenadas
          { wch: 30 }, // Estado
          { wch: 50 }, // Notas
        ];
        ws["!cols"] = colWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, "Ventas en Curso");

        // Generate filename with current date and filters
        const currentDate = new Date()
          .toLocaleDateString("es-ES", {
            timeZone: "America/Guayaquil",
          })
          .replace(/\//g, "-");
        let filename = `Ventas_En_Curso_${currentDate}`;

        if (this.selectedStatus !== "all") {
          filename += `_${this.selectedStatus.replace(/\s+/g, "_")}`;
        }

        if (this.selectedWeek !== "all") {
          const weekLabel =
            this.selectedWeek === "current"
              ? "Semana_Presente"
              : "Semana_Anterior";
          filename += `_${weekLabel}`;
        }

        filename += ".xlsx";

        // Save file
        XLSX.writeFile(wb, filename);

        this.$toast.success(`Archivo Excel descargado: ${filename}`, {
          position: "top-right",
          max: 10,
        });
      } catch (error) {
        console.error("Error al exportar a Excel:", error);
        this.$toast.error("Error al generar el archivo Excel", {
          position: "top-right",
          max: 10,
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.notesContainer {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  align-items: center;
}

.notesContainer:hover {
  background-color: #f2f2f2;
  border-radius: 5px;
}

.copyable-field {
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}

.copyable-field:hover {
  background-color: #f2f2f2;
  border-radius: 3px;
}

.copyable-field:hover::after {
  content: "🔗";
  // font-size: 12px;
  margin-left: 5px;
  opacity: 0.7;
}

.modal__content .form-control.copyable-field:hover {
  background-color: #e9ecef;
}

/* Services Section Styles */
.services-section {
  margin: 15px 0;
}

.services-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
}

.service-card {
  flex: 1;
  min-width: 90px;
  padding: 12px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;
}

.service-card.active {
  background-color: #f9eeff;
  border-color: #7d0c7e;
}

.service-icon {
  font-size: 20px;
  margin-bottom: 8px;
  color: #7d0c7e;
}

.zapping-service-logo {
  display: block;
  width: 22px;
  height: 22px;
  object-fit: contain;
  margin-bottom: 8px;
}

.service-name--zapping {
  color: #7d0c7e;
  font-weight: 700;
}

.service-name {
  font-weight: 600;
  margin-bottom: 6px;
  color: #2c3e50;
  font-size: 14px;
}

.service-status {
  font-size: 12px;
  color: #6c757d;
  padding: 3px 6px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}

.service-card.active .service-status {
  background-color: rgba(125, 12, 126, 0.15);
  color: #7d0c7e;
  font-weight: 500;
}

.budget-description-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.budget-box,
.description-box {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
}

.budget-box {
  border-left: 4px solid #f9cc03;
}

.description-box {
  border-left: 4px solid #7d0c7e;
}

.budget-title,
.description-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
}

.budget-value {
  font-size: 14px;
  font-weight: 600;
  color: #f9cc03;
  padding: 4px 10px;
  background-color: rgba(249, 204, 3, 0.1);
  display: inline-block;
  border-radius: 4px;
}

.description-content {
  color: #4a4a4a;
  line-height: 1.5;
  font-size: 14px;
  white-space: pre-wrap;
}

/* Filter section styles */
.btn-success {
  background-color: #28a745;
  border-color: #28a745;
  transition: all 0.3s ease;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-success i {
  color: white;
}
</style>
